module.exports = "<header class=\"mms-header\">\r\n    <div class=\"mms-header-logo\">\r\n\t    <img class=\"img-responsive\" src=\"/app/img/welcome-mms-plus-ko.png\" alt=\"MyMedSchedule Plus\">\r\n    </div>\r\n    <h3 class=\"mms-header-label text-center text-ko\">{{$ctrl.label}}</h3>\r\n</header>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/banner/banner.html
// module id = 485
// module chunks = 0